<template>
  <span
    class="social-security-number-value"
    :class="{ 'has-error': required && !isValid }"
  >
    <template v-if="isValid && canShowUnmaskedValue">
      <pc-tooltip value="Click to copy, and toggle visibility.">
        <a
          href="#"
          @click.prevent="numberClicked"
          data-id="afa77cb83ee4809dd6d1b875ce0762e8"
          v-if="currentTaxIdType === 'employerIdentificationNumber'"
        >
          {{ currentValue | employerIdentificationNumber }}
        </a>
        <a
          href="#"
          @click.prevent="numberClicked"
          data-id="5ddcc4776105181f0c350785819c268d"
          v-else-if="currentTaxIdType === 'w8Ben'"
        >
          {{ currentValue }}
        </a>
        <a href="#" @click.prevent="numberClicked" data-id="d3d66b4fa0f93f569654f21b71dccd30" v-else>
          {{ currentValue | socialSecurityNumber }}
        </a>
      </pc-tooltip>
      <input
        type="text"
        v-model="unmaskedValue"
        v-if="copying"
        data-id="dcd0d3e23d8e5c1ecd468bb7b23ecd7d"
        style="opacity: 0; width: 10px; height: 1px; position: absolute"
      />
    </template>
    <template v-else>
      {{ displayedValue }}
    </template>
  </span>
</template>

<script>
import $ from "jquery";
import Participant from "@/shared/lib/client-sdk/models/participant";

export default {
  props: {
    value: {
      type: String,
    },
    participant: {
      type: Participant,
    },
    required: {
      type: Boolean,
    },
    flagMissingData: {
      type: Boolean,
    },
    taxIdType: {
      type: String,
    },
  },
  data: function () {
    return {
      isShowing: false,
      copying: false,
    };
  },
  methods: {
    numberClicked: function () {
      if (this.canShowUnmaskedValue) this.isShowing = !this.isShowing;

      this.copying = true;

      this.$nextTick(() => {
        $(this.$el).children("input").focus();
        $(this.$el).children("input").select();
        document.execCommand("copy");
        this.copying = false;

        this.$snackbar.show(
          "'" + this.unmaskedValue + "' copied to clipboard."
        );
      });
    },
  },
  computed: {
    canShowUnmaskedValue: function () {
      if (this.$store.state.authenticatedUser.cant("viewFullTaxId"))
        return false;

      return !this.unmaskedValue?.toUpperCase().includes("X");
    },
    currentValue: function () {
      if (this.isShowing) return this.unmaskedValue;

      return this.maskedValue;
    },
    unmaskedValue: function () {
      if (this.participant && this.participant.unmaskedTaxId) {
        return this.participant.unmaskedTaxId.replace(/-/g, "").trim();
      } else if (this.value) {
        return this.value.replace(/-/g, "").trim();
      }

      return null;
    },
    maskedValue: function () {
      let unmaskedValue = this.unmaskedValue;
      let maskedValue = "XXXXX";

      if (unmaskedValue) {
        if (
          this.participant?.taxIdType === "w8Ben" ||
          this.taxIdType === "w8Ben"
        ) {
          return maskedValue + unmaskedValue.substring(5);
        }

        return maskedValue + unmaskedValue.substring(5, 9);
      }

      return null;
    },
    isValid: function () {
      return (
        this.unmaskedValue &&
        (this.participant?.taxIdType === "w8Ben" ||
          this.taxIdType === "w8Ben" ||
          this.unmaskedValue.length == 9) &&
        this.unmaskedValue != "000000000" &&
        this.unmaskedValue != "111111111" &&
        this.unmaskedValue != "999999999"
      );
    },
    currentTaxIdType: function () {
      return this.participant?.taxIdType ?? this.taxIdType;
    },
    displayedValue: function () {
      if (this.isValid && !this.canShowUnmaskedValue) {
        if (this.currentTaxIdType === "employerIdentificationNumber")
          return this.$options.filters.employerIdentificationNumber(
            this.maskedValue
          );

        if (this.currentTaxIdType === "w8Ben") return this.maskedValue;

        return this.$options.filters.socialSecurityNumber(this.maskedValue);
      } else if (!this.isValid && this.unmaskedValue) {
        return `${this.unmaskedValue} (invalid)`;
      } else if (this.required && this.flagMissingData) {
        return "Missing Tax ID";
      }

      return this.maskedValue;
    },
  },
};
</script>

<style lang="scss">
.social-security-number-value {
  a,
  a:link,
  a:visited {
    text-decoration: none;
    color: inherit;
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-color: $penChecksGray;
  }

  &.has-error {
    color: $penChecksRed;
  }
}
</style>
